const displayYear = () => {
  return new Date().getFullYear();
};
